import styled from 'styled-components'

export const GraphHealthCheckDepartmentStyled = styled.div`
  
`
